// Primitivos reutilizables por las entidades del dominio. Lo mínimo
// que necesita más de un archivo (Id, Slug, fechas ISO, imágenes,
// localización, precio). Cualquier cosa específica de una entidad
// va al archivo de esa entidad.
import { z } from 'zod';

export const IdSchema = z.string().min(1);
export const SlugSchema = z
  .string()
  .min(1)
  .regex(/^[a-z0-9-]+$/, 'Slug must be kebab-case');

export const IsoDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/, 'Must be ISO-8601');

export const UrlSchema = z.string().url();

export const ImageRefSchema = z.object({
  url: UrlSchema,
  alt: z.string().default(''),
  width: z.number().int().positive().optional(),
  height: z.number().int().positive().optional(),
});

export const LocationSchema = z.object({
  venue: z.string(),
  address: z.string().optional(),
  city: z.string(),
  region: z.string().optional(),
  country: z.string().default('ES'),
  lat: z.number().optional(),
  lng: z.number().optional(),
});

export const PriceSchema = z.object({
  amount: z.number().nonnegative(),
  currency: z.string().length(3).default('EUR'),
});

export type ImageRef = z.infer<typeof ImageRefSchema>;
export type Location = z.infer<typeof LocationSchema>;
export type Price = z.infer<typeof PriceSchema>;
